import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText } from '@mui/material';
import {
  CustomDialog,
  CustomStack,
  CustomDialogTitle1,
  CustomDialogTitle2,
} from './style';
import { setAlertOpen } from 'app/store/features/toggleSidebarSlice';
import { ColorsV2 } from 'app/constants/color';
import { Buttons } from 'app/constants/sizing';

const Alert = ({ open, setOpen, type, title, text, handleConfirmation }) => {
  const { t } = useTranslation('translation', { keyPrefix: 'alert' });
  const dispatch = useDispatch();

  return (
    <>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <CustomDialog sx={{ background: ColorsV2.primary }}>
          <CustomStack>
            {type === 'Delete' ? (
              <CustomDialogTitle2
                sx={{
                  color: ColorsV2.white,
                }}
              >
                {title}
              </CustomDialogTitle2>
            ) : (
              <CustomDialogTitle1
                sx={{
                  color: ColorsV2.white,
                  textAlign: 'center'
                }}
              >
                {title}
              </CustomDialogTitle1>
            )}
            <DialogContent>
              <DialogContentText
                sx={{
                  color: ColorsV2.textInfo,
                  fontSize: '16px',
                  textAlign: 'center',
                }}
              >
                {text}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                variant={'contained'}
                onClick={() => {
                  handleConfirmation();
                  dispatch(setAlertOpen(false));
                }}
                sx={{
                  ...Buttons.baseStyle.primaryButtonLowPriority,
                }}
              >
                {t('confirm')}
              </Button>
              <Button
                variant='contained'
                onClick={() => setOpen(false)}
                sx={{
                  ...Buttons.baseStyle.primaryButtonHighPriority,
                }}
              >
                {t('cancel')}
              </Button>
            </DialogActions>
          </CustomStack>
        </CustomDialog>
      </Dialog>
    </>
  );
};

export default Alert;
